import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  deleting: boolean;
  /** Warn that the clips go too (not needed for a failed video). */
  warnAboutClips: boolean;
}

/** Confirmation before deleting a project from /projects (card or expired row). */
export function DeleteListItemDialog({ open, onOpenChange, onConfirm, deleting, warnAboutClips }: Props) {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('projectCard.removeProject')}</DialogTitle>
          <DialogDescription>
            {t('projectCard.removeProjectConfirm')}
            {warnAboutClips && (
              <span className="mt-2 block font-medium text-amber-600 dark:text-amber-400">
                ⚠️ {t('projectCard.removeProjectWarning')}
              </span>
            )}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={deleting}>
            {t('common.cancel')}
          </Button>
          <Button variant="destructive" onClick={onConfirm} disabled={deleting}>
            {deleting ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                {t('projectCard.removing')}
              </>
            ) : (
              t('projectCard.remove')
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
